import styled from "styled-components";

export const StyledCrossResult = styled.div`
  font-size: 1.7rem;
  margin: 0 0 3rem;
  color: gray;
  text-align: center;
`;

export const StyledRemark = styled.div`
    font-size: 1.4rem;
    color: gray;
    line-height: 150%;
    margin-bottom: 2rem;
`;